import React from 'react';
import { useAudioPlayer } from './AudioPlayerProvider';
import { Duration } from './Duration';

const ElapsedTime = () => {
    const { played, duration } = useAudioPlayer();
    return <Duration seconds={duration * played} />;
};

const TotalTime = () => {
    const { duration } = useAudioPlayer();
    return <Duration seconds={duration} />;
};

export const Time = () => {
    return (
        <div
            className="player-duration"
            style={{
                marginRight: '16px',
                fontFamily: 'Open Sans, sans-serif',
                fontWeight: '400',
                fontSize: '14px',
                lineHeight: '18px',
                letterSpacing: '-0.4px',
                width: '86px',
                display: 'flex',
                alignItems: 'center',
                height: '100%',
                position: 'absolute',
                left: '35px',
                justifyContent: 'end',
                userSelect: 'none',
                color: 'white',
            }}
        >
            <ElapsedTime />
            &nbsp;
            {' / '}
            &nbsp;
            <TotalTime />
        </div>
    );
};
